import React from 'react'

const MatxSidenavContent = ({ children }) => {
    return <div className="relative flex-grow h-full" style={{width:'100%'}}>{children}</div>
}

export default MatxSidenavContent
